import { createAPIActions } from '../../utils/redux-actions';

export const feedbackForm = createAPIActions('FEEDBACK_FORM');
